import { useRouter } from 'next/router';

const Index = () => {
  const { locale } = useRouter();
  window.location.pathname = `/catalog/${locale}`;
  return null;
};
export default Index;
